import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

// Datetime values are naive wall-clock values tagged UTC, not real UTC instants, so they
// render as their literal digits rather than being converted to the viewer's timezone.
export const formatDateTime = (value, pattern) =>
  format(utcToZonedTime(value, 'UTC'), pattern);

// A CPF shows only its first digits: enough to tell requesters apart.
export const maskCpf = value => {
  const digits = String(value).replace(/\D/g, '');
  return digits.length === 11 ? `${digits.slice(0, 3)}.***.***-**` : '***';
};

// A form answer as the requester gave it, '' when the field was left empty. A CPF stays masked
// unless `revealed`.
export const formatFieldValue = (field, value, { revealed = false } = {}) => {
  if (value === null || value === undefined || value === '') return '';
  if (field.type === 'cpf' && !revealed) return maskCpf(value);
  if (field.type === 'datetime')
    return formatDateTime(value, "dd/MM/yyyy 'às' HH:mm");
  if (field.type === 'date') return formatDateTime(value, 'dd/MM/yyyy');
  if (field.type === 'checkbox') return value ? '✓' : '—';
  return String(value);
};
